import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import Select, { SelectWithUrl } from '~/components/select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import { awsCostCategoryNamesChartOptionPath } from '~/routes'
import { awsChargeTypes } from '~/utils/aws'

export default function AWSDashboardCostCategoriesFilters({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)
  const costCategoryNamesUrl = useMemo(() => awsCostCategoryNamesChartOptionPath(orgId), [orgId])

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <SelectWithUrl
          label={t`Cost Category Name`}
          name='awsCostCategory'
          params={params}
          onChange={onChange}
          url={costCategoryNamesUrl}
          selected={params.awsCostCategory}
        />
      </Col>
      <Col>
        <Select
          label={t`Charge type`}
          name='awsChargeType'
          onChange={onChange}
          options={awsChargeTypes()}
          selected={params.awsChargeType}
        />
      </Col>
    </DashboardFilters>
  )
}
